import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { JwtService } from 'app/core/services/jwt.service';

import { environment } from 'environments/environment';

@Injectable()
export class SurveyService {
  constructor(private http: HttpClient, private jwtService: JwtService) {}

  private baseUrl = `${environment.API_URL}/surveys`;

  createApplicabilitySurvey(props): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'x-auth-scoped-token': this.jwtService.getToken()
      })
    };
    return this.http.post(`${this.baseUrl}/applicability`, props, httpOptions);
  }
}
